import React from 'react';
import { cn } from '../lib/utils';

const AdminLayout = ({ title, description, actions, children, className }) => (
  <section className={cn('flex h-full min-h-0 min-w-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain px-3 py-4 sm:px-4 sm:py-5 lg:px-8 lg:py-6', className)}>
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-4">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold text-[var(--tg-text-primary)] sm:text-2xl">{title}</h1>
        {description && <p className="text-sm text-[var(--tg-text-muted)]">{description}</p>}
      </div>
      {actions && <div className="flex w-full items-center gap-2 sm:w-auto">{actions}</div>}
    </div>
    <div className="min-h-0 min-w-0 flex-1">{children}</div>
  </section>
);

export default AdminLayout;
